import LabelViewModelT from '@/ViewModels/Controls/LabelViewModel';
import SummaryViewModel from '@/ViewModels/SummaryViewModel';
import ComponentManager from '@/Management/ComponentManager';
import RADEnvironmentProxy from '@/Communication/RADEnvironmentProxy';
import { escapeHtml } from '@/Utility/StringFormatter';
export default class DynamicAssociationSummaryViewModel extends SummaryViewModel {
    public packageA: any;
    public packageB: any;
    public connection: any;
    public name: any;
    public to_ACardinalityValue: any;
    public to_AName: any;
    public to_AOrderedList: any;
    public to_APDTypeMetaName: any;
    public to_APDTypeMetaPDO_ID: any;
    public to_BCardinalityValue: any;
    public to_BName: any;
    public to_BOrderedList: any;
    public to_BPDTypeMetaName: any;
    public to_BPDTypeMetaPDO_ID: any;
    private LabelViewModel: any;
    constructor(params: any) {
        super(params);
        this.LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModelT>('LabelViewModel');
        this.packageA = {};
        this.packageA.class = {};
        this.packageA.class.properties = this.observableOrDefault([]);
        this.packageB = {};
        this.packageB.class = {};
        this.packageB.class.properties = this.observableOrDefault([]);
        this.connection = {};
        this.connection.toA = {};
        this.connection.toB = {};
        this.name = this.observableOrDefault(params.name, '');
        this.to_ACardinalityValue = this.observableOrDefault(params.to_ACardinalityValue, '');
        this.to_AName = this.observableOrDefault(params.to_AName, '');
        this.to_AOrderedList = this.observableOrDefault(params.to_AOrderedList, '');
        this.to_APDTypeMetaName = this.observableOrDefault(params.to_APDTypeMetaName, '');
        this.to_APDTypeMetaPDO_ID = this.observableOrDefault(params.to_APDTypeMetaPDO_ID, '');
        this.to_BCardinalityValue = this.observableOrDefault(params.to_BCardinalityValue, '');
        this.to_BName = this.observableOrDefault(params.to_BName, '');
        this.to_BOrderedList = this.observableOrDefault(params.to_BOrderedList, '');
        this.to_BPDTypeMetaName = this.observableOrDefault(params.to_BPDTypeMetaName, '');
        this.to_BPDTypeMetaPDO_ID = this.observableOrDefault(params.to_BPDTypeMetaPDO_ID, '');
        /**
         * Der Name des Package A
         * @type {this.LabelViewModel}
         */
        this.packageA.header = (() => {
            return new this.LabelViewModel({
                caption: this.defineComputed(() => {
                    let to_BPDTypeMetaName = this.to_BPDTypeMetaName();
                    let split = to_BPDTypeMetaName.split('.');
                    return split[0];
                })
            });
        })();
        /**
         * Der Klassenname des Package A
         * @type {this.LabelViewModel}
         */
        this.packageA.class.name = (() => {
            return new this.LabelViewModel({
                caption: this.defineComputed(() => {
                    let to_BPDTypeMetaName = this.to_BPDTypeMetaName();
                    let split = to_BPDTypeMetaName.split('.');
                    return split[split.length - 1];
                })
            });
        })();
        /**
         * Die Properties der Klasse in Package A
         * @type {[this.LabelViewModel]}
         */
        (() => {
            let pdoId = this.to_BPDTypeMetaPDO_ID();
            this.getProperties(pdoId).then((labels) => {
                this.packageA.class.properties(labels);
            });
        })();
        /**
         * Der Name des Package B
         * @type {this.LabelViewModel}
         */
        this.packageB.header = (() => {
            return new this.LabelViewModel({
                caption: this.defineComputed(() => {
                    let to_APDTypeMetaName = this.to_APDTypeMetaName();
                    let split = to_APDTypeMetaName.split('.');
                    return split[0];
                })
            });
        })();
        /**
         * Der Klassenname des Package B
         * @type {this.LabelViewModel}
         */
        this.packageB.class.name = (() => {
            return new this.LabelViewModel({
                caption: this.defineComputed(() => {
                    let to_APDTypeMetaName = this.to_APDTypeMetaName();
                    let split = to_APDTypeMetaName.split('.');
                    return split[split.length - 1];
                })
            });
        })();
        /**
         * Die Properties der Klasse in Package B
         * @type {[this.LabelViewModel]}
         */
        (() => {
            let pdoId = this.to_APDTypeMetaPDO_ID();
            this.getProperties(pdoId).then((labels) => {
                this.packageB.class.properties(labels);
            });
        })();
        /**
         * Die Überschrift "Dynamische Assoziation"
         * @type {this.LabelViewModel}
         */
        this.connection.title = (() => {
            return new this.LabelViewModel({
                ergName: 'RAD.RADFOUNDATION.PROBLEMDOMAIN.META.DYNAMICASSOZIATION_ERGNAME'
            });
        })();
        /**
         * Der Name der Assoziation
         * @type {this.LabelViewModel}
         */
        this.connection.name = (() => {
            return new this.LabelViewModel({
                caption: this.name,
                prefix: '"',
                postfix: '"'
            });
        })();
        /**
         * Der Name der Assoziation nach A
         * @type {this.LabelViewModel}
         */
        this.connection.toA.name = (() => {
            return new this.LabelViewModel({
                caption: this.to_AName
            });
        })();
        /**
         * Der Name der Assoziation nach B
         * @type {this.LabelViewModel}
         */
        this.connection.toB.name = (() => {
            return new this.LabelViewModel({
                caption: this.to_BName
            });
        })();
        /**
         * Die Multiplizität nach A
         * @type {this.LabelViewModel}
         */
        this.connection.toA.multiplicity = (() => {
            return new this.LabelViewModel({
                caption: this.to_ACardinalityValue
            });
        })();
        /**
         * Die Multiplizität nach B
         * @type {this.LabelViewModel}
         */
        this.connection.toB.multiplicity = (() => {
            return new this.LabelViewModel({
                caption: this.to_BCardinalityValue
            });
        })();
    }
    /**
     * Ruft die Properties zu einer PdoId ab
     */
    private getProperties(pdoId: any): any {
        let result = [];
        let pdTypeName = 'RAD.RADFoundation.ProblemDomain.Meta.PDTypeMeta';
        let assoziationName = 'Properties';
        let properties = ['Name', 'DotNetTypeName'];
        let order = null;
        let retrieveExtentCount = true;
        let iteratorOperator = null;
        return RADEnvironmentProxy.getInstance().createIteratorForAssoziation({
            pdTypeName: pdTypeName,
            pdo_id: pdoId,
            assoziationName: assoziationName,
            properties: properties,
            orderby: order,
            retrieveExtentCount: retrieveExtentCount,
            itOperator: iteratorOperator,
            filter: ''
            //_async: false
        }).then((iterator) => {
            let iteratorId = iterator.id;
            let start = 0;
            let end = iterator.extentCount;
            return RADEnvironmentProxy.getInstance().getExtent({
                iteratorID: iteratorId,
                start: start,
                end: +end,
                //_async: false
            }).then((arrayOfGeneric) => {
                for (let i = 0; i < arrayOfGeneric.length; i++) {
                    let name = arrayOfGeneric[i][0];
                    let type = escapeHtml(arrayOfGeneric[i][1], true);
                    if (type.substring(0, 19) === 'System.Nullable`1[[') {
                        type = type.replace('System.Nullable`1[[', '');
                        let commaIndex = type.indexOf(',');
                        if (commaIndex > -1) {
                            type = type.substring(0, commaIndex) + '?';
                        }
                    }
                    let split = type.split('.');
                    if (split.length > 1) {
                        type = split[split.length - 1];
                    }
                    let blankIndex = type.indexOf(' ');
                    if (blankIndex > -1) {
                        type = type.substring(0, blankIndex);
                    }
                    if (name !== 'ObjectIdentValue' && name !== 'IsModified' && name !== 'Modified' && name.substring(0, 4) !== 'PDO_' && name.toLowerCase().indexOf('nullable') === -1) {
                        result.push(new this.LabelViewModel({
                            caption: name,
                            postfix: new this.LabelViewModel({
                                prefix: ': ',
                                caption: type
                            })
                        }));
                    }
                }
                return result;
            }).always(() => {
                RADEnvironmentProxy.getInstance().deleteIterator({
                    iteratorID: iteratorId,
                    //_async: false
                });
            });
        });
    }
}

ComponentManager.setViewModel('DynamicAssociationSummaryViewModel', DynamicAssociationSummaryViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');